// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-text {
  font-size: 1.1rem;
  text-align: center;
}

.content-fixture {
  font-size: 1.4rem;
  font-weight: 600;
}

.modal-footer {
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/reject-confirm/reject-confirm.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,kBAAA;AACJ;;AACA;EACI,iBAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,uBAAA;AAGJ","sourcesContent":[".content-text {\n    font-size: 1.1rem;\n    text-align: center;\n}\n.content-fixture {\n    font-size: 1.4rem;\n    font-weight: 600;\n}\n.modal-footer {\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
